import moment from "moment";

const easyDateCreator = (daysList: any[]) => {
  let days: any[] = [];
  daysList
    .filter((day) => day.AVAILABILITY.AVAILABLE._text !== "0")
    .map((dayInfo) => {
      let text = "";
      if (moment(dayInfo.DATE._text).format("D MMM") === moment().format("D MMM")) {
        text = "Today";
      } else if (moment(dayInfo.DATE._text).format("D MMM") === moment().add(1, "days").format("D MMM")) {
        text = "Tomorrow";
      } else {
        text = moment(dayInfo.DATE._text).format("D MMM");
      }
      days.push({
        text,
        moment: moment(dayInfo.DATE._text),
      });
    });
  return days;
};

export default easyDateCreator;
